import { Container } from "pixi.js"
import CharDisplay, { CharDisplayChar } from "./CharDisplay"
import { MATCH_DURATION } from "./config"

export default class CountDownDisplay extends Container {
  private _charDisplays: CharDisplay[] = []
  private _seconds: number

  get seconds() {
    return this._seconds
  }
  set seconds(value: number) {
    this._seconds = value
    const secondsToTimeString = this._secondsToTimeString(value)
    for (let i = 0; i < 4; i++) {
      this._charDisplays[i].char = secondsToTimeString[i]
    }
  }

  private _secondsToTimeString(seconds: number): CharDisplayChar[] {
    const minutes = Math.floor(seconds / 60)
    const secondsLeft = seconds % 60
    return `${minutes}:${secondsLeft < 10 ? "0" : ""}${secondsLeft}`.split("") as CharDisplayChar[]
  }

  constructor(params: { x: number, y: number }) {
    super({
      x: params.x,
      y: params.y,
    })

    this._seconds = MATCH_DURATION

    // 9:59 seconds
    if (this._seconds > 599) {
      throw new Error("CountDownDisplay only supports up to 599 seconds")
    }

    const secondsToTimeString = this._secondsToTimeString(this._seconds)
    for (let i = 0; i < 4; i++) {
      this._charDisplays.push(new CharDisplay({
        x: i * CharDisplay.DIGIT_WIDTH,
        y: 0,
        char: secondsToTimeString[i]
      }))
      this.addChild(this._charDisplays[i])
    }
  }

  onCountDownEnd?: () => void
}
